/**
 * Feature flags do AgentsFlow.
 *
 * FIXME: idealmente estes flags vêm do backend via /users/me/feature_flags.
 * Hoje estão hardcoded por conta_id (rollout controlado para clientes piloto).
 * Quando backend expor feature flags, substituir leituras de
 * isCloudApiEnabledForAccount(account_id) por user.feature_flags.cloud_api.
 */

// Contas com WhatsApp Cloud API liberado (fase final de desenvolvimento).
const CLOUD_API_ALLOWED_ACCOUNTS = [96, 29, 7];

export function isCloudApiEnabledForAccount(accountId) {
  if (!accountId) return false;
  return CLOUD_API_ALLOWED_ACCOUNTS.includes(Number(accountId));
}
